import { FaqProps } from "@ft/components/common/Faq";

const stringToAsciiFaqData: FaqProps[] = [
  {
    question: "How does the Text to ASCII Converter work?",
    ans: "It works by taking your input text and converting each character into its ASCII equivalent, providing a seamless and efficient conversion experience.",
  },
  {
    question: "Is this tool free to use?",
    ans: "Yes",
  },
  {
    question: "Do I need to install any software to use the it?",
    ans: "No, our tool is a web-based tool, meaning you can use it directly in your browser without the need for any downloads or installations.",
  },
  {
    question: "Is my data safe here?",
    ans: "Absolutely! We prioritize your privacy. The words to ASCII Converter does not store or share your data. It is used only for the conversion process and is immediately discarded afterwards.",
  },
  {
    question: "Can I convert large amounts of text?",
    ans: "Yes, our tool is designed to handle large amounts of text, making it perfect for both small and large conversion tasks.",
  },
];

export default stringToAsciiFaqData;
